import angular from 'angular';
import ServicesModule from '../../../services/services';
import ResourcesModule from '../../../resources/resources';
import template from './gameDevelopersEdit.jade';

export class GameDevelopersEditController {
  /* @ngInject */
  constructor($stateParams, FeesResource, GameDevelopersResource, $state, notify) {
    this.FeesResource = FeesResource;
    this.GameDevelopersResource = GameDevelopersResource;
    this.$state = $state;
    this.notify = notify;
    this.isResourceBeingPersisted = false;

    if ($stateParams.id) {
      this.getResource($stateParams.id);
      this.getFees($stateParams.id);
    } else {
      this.new = true;
      this.resource = {
        store_extended_cohort_dimensions: false
      };
    }
  }

  getResource(game_developer_id) {
    this.GameDevelopersResource.one(game_developer_id).get().then((res) => {
      this.resource = res;
    });
  }

  getFees(game_developer_id) {
    this.FeesResource.getList({game_developer_id}).then((res) => {
      this.fees = res;
    });
  }

  editableFees(fee) {
    return _.includes(['exchange_fee', 'system_fee', 'additional_fee', 'marketplace_rev_share_fee'], fee.type);
  }

  addServiceFee() {
    this.fees.push({type: 'service_fee'});
  }

  saveFees(gameDeveloper){
    _.forEach(this.fees, (fee) => {
      if (fee.id) {
        if (fee.removed) {
          fee.remove();
        } else {
          fee.save();
        }
      } else if (!fee.removed) {
        fee.game_developer_id = gameDeveloper.id;
        this.FeesResource.post(fee).then((res) => fee = res);
      }
    });
  }

  save() {
    this.isResourceBeingPersisted = true;
    if (this.resource.id) {
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    this.GameDevelopersResource.post(this.resource)
      .then((response) => {
        this.saveFees(response);
        this.notify.created('gameDeveloper', this.resource.company_name);
        this.$state.go('app.admin.gameDevelopers.edit', {id: response.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  update() {
    this.resource.save()
      .then((response) => {
        this.saveFees(response);
        this.notify.updated('gameDeveloper', this.resource.company_name);
        this.$state.go('app.admin.gameDevelopers.edit', {id: this.resource.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }
}

export function GameDevelopersEditComponent() {
  return {
    template,
    controller: GameDevelopersEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      title: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.gameDevelopers.edit', [
  ServicesModule.name,
  ResourcesModule.name
])
.directive('gameDevelopersEdit', GameDevelopersEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/gameDevelopers/gameDevelopersEdit.js
 **/